import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { AppDispatch } from './store';
import { AgencyEnabledFeatures, AgencyInfoAccountType } from '@urbanx/agx.agencies.client';

interface AgentInfoState {
  agentId: string | null;
  agencyId: string | null;
  accountType: AgencyInfoAccountType | null;
  featureToggles: AgencyEnabledFeatures | null;
}

const initialState = {
  agentId: null,
  agencyId: null,
  accountType: null,
  featureToggles: null,
} satisfies AgentInfoState as AgentInfoState;

const slice = createSlice({
  name: 'agentInfo',
  initialState: initialState,
  reducers: {
    agentUpdate: (
      state,
      action: PayloadAction<{
        agent: string | null;
        agency: string | null;
        accountType?: AgencyInfoAccountType | null;
      }>
    ) => {
      return {
        ...state,
        agentId: action.payload.agent,
        agencyId: action.payload.agency,
        accountType:
          action.payload.accountType === undefined ? state.accountType : action.payload.accountType,
      };
    },
    featureTogglesLoaded: (state, action: PayloadAction<AgencyEnabledFeatures | null>) => {
      return {
        ...state,
        featureToggles: action.payload,
      };
    },
  },
});

export default slice.reducer;

// Actions
const { agentUpdate, featureTogglesLoaded } = slice.actions;

export const updateAgent =
  (agent: {
    agent: string | null;
    agency: string | null;
    accountType?: AgencyInfoAccountType | null;
  }) =>
  async (dispatch: AppDispatch) => {
    dispatch(agentUpdate(agent));
  };

export const updateFeatureToggles =
  (featureToggles: AgencyEnabledFeatures | null) => async (dispatch: AppDispatch) => {
    dispatch(featureTogglesLoaded(featureToggles));
  };
